import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { useCachedSettingsState } from 'PublicWebApi'
import { useLanguageDisclaimer } from '../../hooks/useLanguageDisclaimer'
const LanguageDisclaimerModal = () => {
  const { open, handleClose } = useLanguageDisclaimer()
  const { disclaimerText } = useCachedSettingsState()

  if (!disclaimerText) return null

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="language-disclaimer-title"
      aria-describedby="language-disclaimer-description"
    >
      <DialogTitle id="language-disclaimer-title">
        Automatic translation
      </DialogTitle>
      <DialogContent>
        <Typography data-testid="language-disclaimer-description">
          {disclaimerText}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={handleClose}>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default LanguageDisclaimerModal
